import { makeUseAxios } from 'axios-hooks';
import { LRUCache } from 'lru-cache';
import axios from 'axios';
import { env } from 'Shared/constants/env';
import { makeApiHooks } from './makeHooks';

const cache = new LRUCache<any, any>({ max: 10 });

const cancelInterceptor = (error: any) => {
  if (axios.isCancel(error)) {
    // don't throw any error in canceled request
    return new Promise(() => {});
  }
  return Promise.reject(error);
};

const axiosV1 = axios.create({
  baseURL: `${env.varysHostname}/v1/portal`,
  headers: { Source: `core-app/${env.versionNumber}` },
});

axiosV1.interceptors.response.use((response) => response, cancelInterceptor);

const useAxios = makeUseAxios({
  axios: axiosV1,
  cache: cache as any,
});

const axiosV2 = axios.create({
  baseURL: `${env.varysHostname}/v2/portal`,
  headers: { Source: `core-app/${env.versionNumber}` },
});

axiosV2.interceptors.response.use((response) => response, cancelInterceptor);

const useAxiosV2 = makeUseAxios({
  axios: axiosV2,
  cache: cache as any,
});

export const { useLazyApi, useApi, useNewApi } = makeApiHooks(useAxios);
export const {
  useLazyApi: useLazyApiV2,
  useApi: useApiV2,
  useNewApi: useNewApiV2,
} = makeApiHooks(useAxiosV2);
